document.addEventListener('DOMContentLoaded', function() {

  // 1. Global Vars / Constants
  let currentStep = 1;
  const region = document.querySelector('[data-id="klaviyo_region"]')?.value || 'uk';
  const isUK = region === 'uk';
  let productType = null;
  
  // DOM elements
  const form = document.getElementById('multiStepForm');
  const steps = document.querySelectorAll('.step');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  const submitBtn = document.getElementById('submitBtn');
  const progressBar = document.querySelector('.progress-bar-fill');
  const stepIndicators = document.querySelectorAll('.step-indicator');
  const voltageField = document.getElementById('voltage');
  const voltageSelect = document.getElementById('voltage');
  const voltagePlaceholder = document.getElementById('voltage_select');
  const modelSelectContainer = document.getElementById('productModel-container');
  const select110 = document.getElementById('productModel-110v');
  const select230 = document.getElementById('productModel-230v');
  const selectCordless = document.getElementById('productModel-cordless');
  const selectDefault = document.getElementById('productModel-default');
  const serialInput = document.querySelector('[data-id="serialNumber"]');
  const productItems = document.querySelectorAll('.product-item');
  const selectedProductInput = document.querySelector('[data-id="selectedProduct"]');

  // 2. Utility Functions
  function hideAllProductModelSelects() { 
    [select110, select230, selectCordless, selectDefault].forEach(sel => {
      if (sel) {
        sel.style.display = 'none';
        sel.removeAttribute('name');
      }
    }); 
  }
  function parseWarrantyPeriod(warrantyString) { 
    if (!warrantyString || typeof warrantyString !== 'string') {
          return 0;
        }
        
        const clean = warrantyString.trim().toLowerCase();
        const match = clean.match(/^(\d+(?:\.\d+)?)\s*(year|years|yr|yrs|month|months|mo|day|days)s?$/);
        
        if (!match) {
          console.log(`Could not parse warranty string: "${warrantyString}"`);
          return 0;
        }
        
        const value = parseFloat(match[1]);
        const unit = match[2];
        
        if (unit.startsWith('year') || unit === 'yr' || unit === 'yrs') {
          return value;
        } else if (unit.startsWith('month') || unit === 'mo') {
          return value / 12;
        } else if (unit.startsWith('day')) {
          return value / 365;
        }
        
        return 0;
} // ✅ ← MISSING CLOSING BRACE HERE
  function calculateExpiryDate(purchaseDate, warrantyPeriod) { 
  if (!purchaseDate) return null;
        
        // Parse purchase date
        const purchaseDateTime = new Date(purchaseDate);
        if (isNaN(purchaseDateTime.getTime())) return null;
        
        // Parse warranty period
        let warrantyYears;
        if (typeof warrantyPeriod === 'string') {
          warrantyYears = parseWarrantyPeriod(warrantyPeriod);
        } else if (typeof warrantyPeriod === 'number') {
          warrantyYears = warrantyPeriod;
        } else {
          return null;
        }
        
        if (warrantyYears <= 0) return null;
        
        // Calculate expiry date
        const expiryDate = new Date(purchaseDateTime);
        
        const wholeYears = Math.floor(warrantyYears);
        const remainingMonths = Math.round((warrantyYears - wholeYears) * 12);
        
        expiryDate.setFullYear(expiryDate.getFullYear() + wholeYears);
        expiryDate.setMonth(expiryDate.getMonth() + remainingMonths);
        
        return expiryDate;  
  }
  function formatSalesforceDate(input) { 
    if (!input) return '';
        const date = new Date(input);
        if (isNaN(date.getTime())) return '';
        return date.toISOString().split('T')[0]; // "YYYY-MM-DD"
  }
  function validateEmail(email) { return /\S+@\S+\.\S+/.test(email); }
  function validatephone(phone) { 
    const cleaned = phone.replace(/\D/g, ''); // Remove all non-digit characters
    return cleaned.length >= 7; // Acceptable if at least 7 digits
  }
  function getFieldValueByName(formElement, dataName) { 
    const checkedRadio = formElement.querySelector(`[data-name="${dataName}"]:checked`);
    if (checkedRadio) return checkedRadio.value;
    const field = formElement.querySelector(`[data-name="${dataName}"]`);
    return field ? field.value : null;
  }
  function getMultipleFieldValuesByName(formElement, dataName) { 
    return Array.from(formElement.querySelectorAll(`[data-name="${dataName}"]:checked`))
    .map(cb => cb.value); 
  }

  // 3. Initial UI Setup
  if (serialInput) {
    serialInput.addEventListener('input', function () {
      this.value = this.value.toUpperCase();
    });
  }
  
  const productModelLabel = document.querySelector('.product-model-name');
  const selectedProductModelLabel = document.getElementById('selectedProductModelLabel');
  if (selectedProductModelLabel) selectedProductModelLabel.style.display = 'none';
  if (productModelLabel) productModelLabel.textContent = '';
  
  const purchaseDateInput = document.querySelector('[data-id="purchaseDate"]');
  if (purchaseDateInput) {
    const today = new Date().toISOString().split('T')[0];
    purchaseDateInput.max = today;
    purchaseDateInput.addEventListener('change', () => {
      const selectedWarranty = document.querySelector('select[name="productModel"] option:checked')?.dataset.warranty;
      const purchaseDate = purchaseDateInput.value;
      if (selectedWarranty && purchaseDate) {
        updateWarrantyExpiryDisplay(purchaseDate, selectedWarranty);
      }
    });
  }

  // 4. Product Type & Voltage Logic
  function setVoltageVisibility(productType) { 
  if (!isUK) {
    selectDefault.style.display = 'block';
    selectDefault.setAttribute('name', 'productModel');

    if (!selectDefault || !voltageField) {
    console.warn('Missing selectDefault or voltageField – skipping voltage logic');
    return false;
    }
  }
  const voltageError = document.getElementById('voltageError');

  const voltageRequiredTypes = ['circular_saws', 'chop_saws', 'disc_cutters', 'dry_wall_sanders', 'handheld_drills', 'handheld_mixers', 'magnetic_drills', 'mitre_saws', 'table_saws'];
  const requiresVoltage = voltageRequiredTypes.includes(productType);

  if (voltageField && voltageField.closest('.form-group')) {
    voltageField.closest('.form-group').style.display = requiresVoltage ? 'block' : 'none';

    if (requiresVoltage) {
      voltageField.setAttribute('required', 'required');
      voltageError && (voltageError.style.display = 'none');

      
      // Only reset voltage if user is changing product type to one that requires voltage
      if (requiresVoltage) {
        //voltageField.selectedIndex = 0;
        //voltageField.dispatchEvent(new Event('change', { bubbles: true }));
        modelSelectContainer.style.display = 'none'; // ✅ hide initially
      } else {
          modelSelectContainer.style.display = 'block'; // show immediately if not voltage-dependent
      }

      // hide all voltage-select dropdowns
      if (select110) select110.style.display = 'none';
      if (select230) select230.style.display = 'none';
      if (selectCordless) selectCordless.style.display = 'none';
      if (select110) select110.removeAttribute('name');
      if (select230) select230.removeAttribute('name');
      if (selectCordless) selectCordless.removeAttribute('name');
    } else {
      voltageField.removeAttribute('required');
      voltageField.removeAttribute('name');
      
      voltageError && (voltageError.style.display = 'none');

      // ✅ Show default model list
      if (selectDefault) {
        selectDefault.style.display = 'block';
        selectDefault.setAttribute('name', 'productModel');
      }

      // Hide other voltage dropdowns if they exist
      if (select110) select110.style.display = 'none';
      if (select230) select230.style.display = 'none';
      if (selectCordless) selectCordless.style.display = 'none';
      if (select110) select110.removeAttribute('name');
      if (select230) select230.removeAttribute('name');
      if (selectCordless) selectCordless.removeAttribute('name');
    }
  }

  console.log('Region =', isUK ? 'UK' : region, 'Product type:', productType);
  return requiresVoltage;  
  }
  function updateModelOptions(productType, autoTriggerChange = false) { 
  const fullList = document.getElementById('fullProductModelList');

  // ✅ EARLY EXIT: If "dontknow", show all products from 230V
  if (productType === 'dontknow') {
    const modelSelect = select230;
    modelSelect.innerHTML = '';

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.textContent = document.getElementById('translatedProductModelPlaceholder')?.textContent?.trim() || 'Select a product model';
    modelSelect.appendChild(placeholder);

    const allOptgroups = fullList.querySelectorAll('optgroup');
    allOptgroups.forEach(group => {
      [...group.children].forEach(option => {
        const clone = option.cloneNode(true);
        clone.hidden = false;
        modelSelect.appendChild(clone);
      });
    });

    modelSelectContainer.style.display = 'block';
    modelSelect.style.display = 'block';
    modelSelect.setAttribute('name', 'productModel');
    // No longer used.
    // modelSelect.value = newOptionValue; // This must match an option's value exactly

    if (autoTriggerChange) {
      modelSelect.dispatchEvent(new Event('change'));
    }
    return; // ✅ Important: Exit early
  }
  
  const voltage = isUK ? voltageSelect.value : null;

  let selector;

  if (isUK) {
    const requiresVoltage = setVoltageVisibility(productType);
    if (requiresVoltage) {
      selector = `optgroup[data-product-type="${productType}"][data-voltage="${voltage}"]`;
    } else {
    selector = `optgroup[data-product-type="${productType}"]`;
    }
  } else {
    selector = `optgroup[data-product-type="${productType}"][data-region="${region}"]`;
  }

  let modelSelect = selectDefault;

  if (isUK && voltage === '110V') modelSelect = select110;
  else if (isUK && voltage === '230V') modelSelect = select230;
  else if (isUK && voltage === 'Cordless') modelSelect = selectCordless;
  else if (isUK) modelSelect = selectDefault; // fallback if voltage missing

  const matchingGroup = fullList.querySelector(selector);
  modelSelect.innerHTML = '';

  const placeholder = document.createElement('option');
  placeholder.value = '';
  placeholder.disabled = true;
  placeholder.selected = true;
  placeholder.textContent = document.getElementById('translatedProductModelPlaceholder')?.textContent?.trim() || 'Select a product model';

  modelSelect.appendChild(placeholder);

  if (matchingGroup) {
    modelSelect.appendChild(matchingGroup.cloneNode(true));
  } else {
    const fallback = document.createElement('option');
    fallback.value = '';
    fallback.textContent = 'No models available for this category';
    modelSelect.appendChild(fallback);
  }

  // Hide all productModel selects and remove name attributes
  hideAllProductModelSelects();


  // ✅ Only show and name the correct one
  modelSelectContainer.style.display = 'block';
  modelSelect.style.display = 'block';
  modelSelect.setAttribute('name', 'productModel');

  if (autoTriggerChange && modelSelect) {
    modelSelect.dispatchEvent(new Event('change'));
  }

  console.log('👀 Region:', region, '| productType:', productType, '| selector:', selector);
  console.log('🔎 Found matching group?', matchingGroup);  
  }
  function handleProductModelChange(event) { 
  const modelSelect = event.target;
  const selectedOption = modelSelect.options[modelSelect.selectedIndex];

  if (!selectedOption || !selectedOption.value) {
    // Hide summary label if no valid option selected
    const selectedProductModelLabel = document.getElementById('selectedProductModelLabel');
    if (selectedProductModelLabel) {
      selectedProductModelLabel.style.setProperty('display', 'none', 'important');
    }
    return;
  }

  // ✅ Everything below here runs only if a real product is selected:
  const warranty = selectedOption.dataset.warranty;
  const warrantyDisplay = document.getElementById('warrantyDisplay');
  const warrantyValue = document.getElementById('warrantyValue');
  const productModelLabel = document.querySelector('.product-model-name');
  const selectedProductModelLabel = document.getElementById('selectedProductModelLabel');
  
  if (productModelLabel && selectedOption?.textContent) {
    productModelLabel.textContent = selectedOption.textContent.trim();
    if (selectedProductModelLabel) {
      selectedProductModelLabel.style.setProperty('display', 'flex', 'important');
    }
  }

  // ✅ Update warranty info box
  if (warranty) {
    warrantyDisplay.style.display = 'flex';
    warrantyValue.textContent = warranty;
  } else {
    warrantyDisplay.style.display = 'none';
    warrantyValue.textContent = '';
  }

  // ✅ Trigger expiry update if purchase date is already selected
  const purchaseDate = document.querySelector('[data-id="purchaseDate"]')?.value;
  if (purchaseDate && warranty) {
    updateWarrantyExpiryDisplay(purchaseDate, warranty);
  }

  const sku = selectedOption.value;
  const label = selectedOption.textContent;
  const imageUrl = `https://www.evolutionpowertools.com/images/canvas/registerpage/product/all/${sku}.jpg`;

  const productImage = document.getElementById('productImage');
  const productTitle = document.getElementById('productTitle');

  if (productImage && productTitle && sku) {
    productImage.src = imageUrl;
    productImage.alt = label;
    productTitle.textContent = label;
  } else {
    if (productImage) productImage.src = '';
    if (productTitle) productTitle.textContent = '';
  }

  const productDetails = document.querySelector('.selected_product_details');
  productDetails.style.display = sku ? 'block' : 'none';  
  }
  function updateWarrantyExpiryDisplay(purchaseDate, warrantyString) { 
  const expiryLabel = document.querySelector('.warranty_expiry');
  const expiryDate = calculateExpiryDate(purchaseDate, warrantyString);
  
  if (expiryLabel && expiryDate) {
    expiryLabel.textContent = expiryDate.toISOString().split('T')[0];
    expiryLabel.closest('h5').style.display = 'flex'; // 👈 Show expiry summary
  }  
  }
  
  
productItems.forEach(item => {
  item.addEventListener('click', (e) => {
    const selectedProductType = item.dataset.productType;

    // ✅ If it's the 'dontknow' type, stop here and let the popup handler take over
    if (selectedProductType === 'dontknow') {
      console.log('🟨 "I don’t know" clicked — showing popup only');
      return; // Do not advance to step 2
    }

    console.log('✅ Product item clicked');
    productItems.forEach(p => p.classList.remove('selected'));
    item.classList.add('selected');

    productType = selectedProductType;
    selectedProductInput.value = selectedProductType;

    const labelContainer = document.querySelector('#selectedProductTypeLabel .product-type-name');
    if (labelContainer) {
      labelContainer.textContent = item.textContent.trim();
      labelContainer.closest('h5').style.display = 'flex';
    }

    document.getElementById('productTypeError').style.display = 'none';

    const requiresVoltage = setVoltageVisibility(selectedProductType);

    if (isUK && requiresVoltage && voltageSelect) {
      voltageSelect.value = '';
      voltageSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (!requiresVoltage) {
      updateModelOptions(selectedProductType, true);
    }

    console.log('👉 Advancing to step 2');
    setCurrentStep(2);
  });
});



  
  [select110, select230, selectCordless, selectDefault].forEach(select => {
    if (select) select.addEventListener('change', handleProductModelChange);
  });
  
if (voltageSelect) {
  voltageSelect.addEventListener('change', function () { 
    const selectedValue = this.value;

  hideAllProductModelSelects();

  if (modelSelectContainer) {
    modelSelectContainer.style.display = selectedValue ? 'block' : 'none';
  }

  // Show the correct product model dropdown
  if (selectedValue === '110V' && select110) {
    select110.style.display = 'block';
    select110.setAttribute('name', 'productModel');
  } else if (selectedValue === '230V' && select230) {
    select230.style.display = 'block';
    select230.setAttribute('name', 'productModel');
  } else if (selectedValue === 'Cordless' && selectCordless) {
    selectCordless.style.display = 'block';
    selectCordless.setAttribute('name', 'productModel');
  }

  // ✅ Fix: Refetch correct models for selected product type + voltage
  const selectedProductType = selectedProductInput.value;
  if (selectedProductType) {
    updateModelOptions(selectedProductType, true);
  }
  });
}
  // 5. Step Navigation
  function setCurrentStep(stepNumber) { 
    if (stepNumber < 1 || stepNumber > steps.length) return;
      
        currentStep = stepNumber; 
      
        // Show the correct step
        steps.forEach(step => step.classList.remove('active'));
        stepIndicators.forEach(indicator => indicator.classList.remove('active'));
      
        document.querySelector(`[data-step="${stepNumber}"]`)?.classList.add('active');
        stepIndicators[stepNumber - 1]?.classList.add('active');
      
        // Progress bar
        progressBar.style.width = `${(stepNumber / steps.length) * 100}%`;
      
        // Button visibility
        prevBtn.style.display = stepNumber === 1 ? 'none' : 'block';
        nextBtn.style.display = stepNumber === steps.length ? 'none' : 'block';
        submitBtn.style.display = stepNumber === steps.length ? 'block' : 'none';
      
        // Extra: control visibility of product summary or review area
        const productDetails = document.querySelector('.selected_product_details');
        const summarySection = document.querySelector('.final_third');
      
        if (productDetails) {
          productDetails.style.display = stepNumber === 2 ? 'block' : 'none';
        }
      
        if (summarySection) {
          summarySection.style.display = stepNumber === 2 ? 'flex' : 'none';
        }
      
        console.log('✅ Step shown:', stepNumber);
  }
  function validateStep(stepNumber) { 
    if (stepNumber === 1) {
          const error = document.getElementById('productTypeError');
          if (!selectedProductInput.value) {
            error.style.display = 'block';
            return false;
          }
          error.style.display = 'none';
          return true;
        } 
        else if (stepNumber === 2) {
          console.log('🔁 Validating Step 2');
          let isValid = true;
          const productModelSelect = document.querySelector('select[name="productModel"]');
          const productModel = productModelSelect ? productModelSelect.value : '';
          const purchaseDate = document.querySelector('[data-id="purchaseDate"]').value;
          
          const modelError = document.getElementById('productModelError');
          const serialError = document.getElementById('serialNumberError');
          const serialCharacterLimitError = document.getElementById('serialNumberCharacterLimitError');
 
          const dateError = document.getElementById('purchaseDateError');

          const voltageField = document.getElementById('voltage');
          const voltageError = document.getElementById('voltageError');
          const requiresVoltage = voltageSelect?.hasAttribute('required');
          if (requiresVoltage) {
            if (!voltageSelect.value) {
              voltageError.style.display = 'block';
              isValid = false;
            } else {
              voltageError.style.display = 'none';
            }
          } else {
            if (voltageError) voltageError.style.display = 'none'; // Hide error if not required
          }
          
          if (!productModel) {
            if (modelError) modelError.style.display = 'block';
            isValid = false;
          } else {
            if (modelError) modelError.style.display = 'none';
          }
          
          const serialNumber = document.querySelector('[data-id="serialNumber"]').value.trim().toUpperCase();
          const serialStartsWithBarcode = serialNumber.startsWith('50565830') || serialNumber.startsWith('8497130') || serialNumber.startsWith('08497130');
          const hasLetter = /[A-Z]/.test(serialNumber);
          const hasNumber = /\d/.test(serialNumber);
          
          if (!serialNumber || serialNumber.length < 12) {
            serialCharacterLimitError.style.display = 'block';
            document.getElementById('serialNumberBarcodeError').style.display = 'none';
            document.getElementById('serialNumberLetterNumberError').style.display = 'none';
            isValid = false;
          } else if (serialStartsWithBarcode) {
            document.getElementById('serialNumberBarcodeError').style.display = 'block';
            serialCharacterLimitError.style.display = 'none';
            document.getElementById('serialNumberLetterNumberError').style.display = 'none';
            isValid = false;
          } else if (!hasLetter || !hasNumber) {
            document.getElementById('serialNumberLetterNumberError').style.display = 'block';
            serialCharacterLimitError.style.display = 'none';
            document.getElementById('serialNumberBarcodeError').style.display = 'none';
            isValid = false;
          } else {
            document.getElementById('serialNumberLetterNumberError').style.display = 'none';
            serialCharacterLimitError.style.display = 'none';
            document.getElementById('serialNumberBarcodeError').style.display = 'none';
          }
          
          if (!purchaseDate) {
            dateError.style.display = 'block';
            isValid = false;
          } else {
            dateError.style.display = 'none';
          }
            return isValid;

        }
        else if (stepNumber === 3) {
          const firstName = document.querySelector('[data-id="firstName"]').value.trim();
          const lastName = document.querySelector('[data-id="lastName"]').value.trim();
          const email = document.querySelector('[data-id="email"]').value.trim();
          const phone = document.querySelector('[data-id="phone"]').value.trim();
          
          const firstNameError = document.getElementById('firstNameError');
          const lastNameError = document.getElementById('lastNameError');
          const emailError = document.getElementById('emailError');
          const phoneError = document.getElementById('phoneError');
          const country = document.querySelector('[data-id="country"]').value;
          const countryError = document.getElementById('countryError');
          
          let isValid = true;
          
          if (!firstName) {
            firstNameError.style.display = 'block';
            isValid = false;
          } else {
            firstNameError.style.display = 'none';
          }
          
          if (!lastName) {
            lastNameError.style.display = 'block';
            isValid = false;
          } else {
            lastNameError.style.display = 'none';
          }
          
          if (!email || !validateEmail(email)) {
            emailError.style.display = 'block';
            isValid = false;
          } else {
            emailError.style.display = 'none';
          }
          
          if (!phone || !validatephone(phone)) {
            phoneError.style.display = 'block';
            isValid = false;
          } else {
            phoneError.style.display = 'none';
          }

          if (!country) {
            countryError.style.display = 'block';
            isValid = false;
          } else {
            countryError.style.display = 'none';
          }

          console.log({
            firstName,
            lastName,
            email,
            emailValid: validateEmail(email),
            phone,
            phoneValid: validatephone(phone),
            country
          });
            return isValid;
        }

        if (stepNumber === 4) {
         let isValid = true;

          const newsletterYes = document.getElementById('newsletterYes');
          const newsletterNo = document.getElementById('newsletterNo');
          const consent = document.getElementById('consentCheckbox');
      
          if (!newsletterYes.checked && !newsletterNo.checked) {
            document.getElementById('newsletterError').style.display = 'block';
            isValid = false;
          } else {
            document.getElementById('newsletterError').style.display = 'none';
          }
      
          if (!consent.checked) {
            document.getElementById('consentError').style.display = 'block';
            isValid = false;
          } else {
            document.getElementById('consentError').style.display = 'none';
          }
        return isValid; // ✅ this now works correctly
        }
  }
  
  prevBtn.addEventListener('click', () => { 
    console.log('👈 Prev clicked. currentStep:', currentStep);
    if (currentStep > 1) setCurrentStep(currentStep - 1); 
  });
  nextBtn.addEventListener('click', () => { 
    console.log('👉 Next clicked. currentStep:', currentStep);
        if (validateStep(currentStep)) {
          console.log('✅ Step valid, moving forward');
          setCurrentStep(currentStep + 1);
        } else {
          console.log('❌ Step invalid, staying on', currentStep);
        }
  });
  form.addEventListener('reset', () => { 
    hideAllProductModelSelects();

        const selectedProductModelLabel = document.getElementById('selectedProductModelLabel');
        if (selectedProductModelLabel) {
          selectedProductModelLabel.style.display = 'none';
        }
  });
  
  setCurrentStep(currentStep);

  // === UPLOAD IMAGE LOGIC ===

const uploadForm = document.getElementById('multiStepForm');
const uploadStatus = document.getElementById('uploadStatus');
const photoInput = document.getElementById('photo');

let uploadedReceiptKey = null; // Tracks uploaded receipt key
let previewImage, fileNameDisplay, removeButton;

// ✅ Create UI Elements Once
function setupUploadUI() {
  // Image Preview
  previewImage = document.createElement('img');
  previewImage.style.maxWidth = '150px';
  previewImage.style.marginTop = '10px';
  previewImage.style.display = 'none';
  uploadStatus.appendChild(previewImage);

  // File Name Display
  fileNameDisplay = document.createElement('div');
  fileNameDisplay.style.marginTop = '8px';
  fileNameDisplay.style.fontSize = '14px';
  uploadStatus.appendChild(fileNameDisplay);

  // Remove Button
  removeButton = document.createElement('button');
  removeButton.type = 'button';
  removeButton.textContent = 'Remove';
  removeButton.style.marginTop = '8px';
  removeButton.style.display = 'none';
  removeButton.addEventListener('click', () => {
    // Reset file input
    photoInput.value = '';
    uploadedReceiptKey = null;
    previewImage.src = '';
    previewImage.style.display = 'none';
    fileNameDisplay.textContent = '';
    removeButton.style.display = 'none';
  });
  uploadStatus.appendChild(removeButton);
}

setupUploadUI();

// ✅ Handle Image Selection
photoInput.addEventListener('change', function () {
  const file = this.files?.[0];
  const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
  const maxSize = 5 * 1024 * 1024; // 5MB

  // Reset error and preview state
  fileNameDisplay.textContent = '';
  previewImage.style.display = 'none';
  previewImage.src = '';
  removeButton.style.display = 'none';
  uploadStatus.classList.remove('error'); // optional styling

  const typeError = document.getElementById('photoTypeError');
  const sizeError = document.getElementById('photoSizeError');

  // Hide all errors
  typeError.style.display = 'none';
  sizeError.style.display = 'none';

  if (!file) return;
  let hasError = false;

  // File type check
  if (!allowedTypes.includes(file.type)) {
    typeError.style.display = 'block';
    hasError = true;
  }
  
  // File size check
  if (file.size > maxSize) {
    sizeError.style.display = 'block';
    hasError = true;
  }

  if (hasError) {
    this.value = ''; // Clear the invalid input
    return;
  }

  // ✅ If valid, show preview and filename
  if (file.type.startsWith('image/')) {
  const reader = new FileReader();
  reader.onload = function (e) {
    previewImage.src = e.target.result;
    previewImage.style.display = 'block';
    };
    reader.readAsDataURL(file);
  } else {
    previewImage.style.display = 'none';
    previewImage.src = '';
  }

  //fileNameDisplay.textContent = file.name;
  removeButton.style.display = 'inline-block';
});


// ✅ Upload to Worker
async function uploadReceiptPhoto(file) {
  if (!file) return null;

  const formData = new FormData();
    formData.append("photo", document.querySelector("#photo").files[0]);

  try {
    const res = await fetch('https://mr-register-form.matt-robinson-0dd.workers.dev/upload-image', {
      method: 'POST',
      body: formData
    });

    const result = await res.json();
    console.log('📤 Upload result:', result); // ✅ Add this

    if (result.success && result.key) {
      uploadedReceiptData = {
        receiptPhotoKey: result.key,
        receiptPhotoUrl: result.url,
        file_name: result.file_name
      };
       console.log("📎 Receipt uploaded:", uploadedReceiptData);
    } else {
      alert("Receipt upload failed: " + result.error);
      return null;
    }
  } catch (err) {
    console.error('Upload error:', err);
    return null;
  }


}





  // 6. Submit Handling
  form.addEventListener('submit', function (e) { 
  console.log('🚨 SUBMIT handler triggered!');
  e.preventDefault();

    if (currentStep < 4) {
      if (!validateStep(currentStep)) return;
      setCurrentStep(currentStep + 1);
      return;
    }
    
// ✅ Only validate when already on step 3
if (!validateStep(3)) return;

  if (!validateStep(currentStep)) return;

  grecaptcha.ready(function () {
    grecaptcha.execute('6Lfh3kIrAAAAAGD4NBTJ6C8m73MZ5TWIwh-t95CU', { action: 'submit' }).then(async function (token) {
      const submitBtn = document.getElementById('submitBtn');
      submitBtn.disabled = true;
      // submitBtn.textContent = 'Submitting...';

      const photoFile = photoInput?.files?.[0] || null;

      // Upload the receipt photo first (if provided)
      const uploadResult = await uploadReceiptPhoto(photoFile);
      console.log("📎 Uploaded receipt result:", uploadResult);

      const receiptKey = uploadResult?.key || null;
      const receiptUrl = uploadResult?.url || null;
      const receiptFileName = uploadResult?.file_name || null;
      console.log("📎 Uploaded receipt result:", uploadResult); // ✅ Add for debugging
      
      try {
        // Construct form payload here AFTER user completes form and token is ready
        const productModelSelect = document.querySelector('select[name="productModel"]');
        const selectedOption = productModelSelect.options[productModelSelect.selectedIndex];
        const productModelId = selectedOption?.value || '';
        const productModelTitle = selectedOption?.textContent || '';
        const warrantyPeriod = selectedOption?.dataset.warranty || '1 Year';

        const purchaseDate = getFieldValueByName(form, 'purchaseDate');
        const klaviyoRegion = getFieldValueByName(form, 'klaviyo_region');
        const klaviyoListId = getFieldValueByName(form, 'klaviyoListId');

        let warrantyExpiry = calculateExpiryDate(purchaseDate, warrantyPeriod);

        const dobDay = getFieldValueByName(form, 'dob_day');
        const dobMonth = getFieldValueByName(form, 'dob_month');
        const dobYear = getFieldValueByName(form, 'dob_year');
        
        let dob = null;
        if (dobYear && dobMonth && dobDay) {
          const y = parseInt(dobYear, 10);
          const m = parseInt(dobMonth, 10) - 1;
          const d = parseInt(dobDay, 10);
          const dobCandidate = new Date(y, m, d);
          if (!isNaN(dobCandidate.getTime())) {
            dob = dobCandidate.toISOString().split('T')[0]; // 'YYYY-MM-DD'
          }
        }

        const salesforceData = {
          email: getFieldValueByName(form, 'email'),
          phone: getFieldValueByName(form, 'phone'),
          firstName: getFieldValueByName(form, 'firstName'),
          lastName: getFieldValueByName(form, 'lastName'),
          country: getFieldValueByName(form, 'country'),
          address1: getFieldValueByName(form, 'address1'),
          postcode: getFieldValueByName(form, 'postcode'),
          town: getFieldValueByName(form, 'town'),
          state: getFieldValueByName(form, 'state'),
          productModel: productModelId,
          serialNumber: getFieldValueByName(form, 'serialNumber'),
          purchasePlace: getFieldValueByName(form, 'purchasePlace'),
          purchaseDate: getFieldValueByName(form, 'purchaseDate'),
          warrantyExpiry: warrantyExpiry ? warrantyExpiry.toISOString().split('T')[0] : null
        };

        const salesforceFormData = {
          orgid: "00DAe000002KugI",
          recordType: "0123z000000OIwc",
        
          email: salesforceData.email,
          phone: salesforceData.phone,
          "00N3z00000CXIm4": salesforceData.firstName,
          "00N3z00000CXIm9": salesforceData.lastName,
          "00N3z00000CX2VM": salesforceData.country,
          "00NAe00000CLLLv": salesforceData.productModel,
          "00N3z00000CX1w7": salesforceData.serialNumber,
          "00NAe000005KB9K": salesforceData.purchasePlace,
          "Form_Asset_Purchased_Date__c": formatSalesforceDate(salesforceData.purchaseDate),
          "00N3z00000CXImO": salesforceData.address1,
          "00N3z00000CXImi": salesforceData.postcode,
          "00N3z00000CXImY": salesforceData.town,
          "00N3z00000CXImd": salesforceData.state,
          "00NAe00000D8A4L": formatSalesforceDate(salesforceData.warrantyExpiry)
        };

        console.log("🧾 FILE NAME TO SUBMIT:", receiptFileName);

        const payload = { 
          operation: 'warranty',
          email: getFieldValueByName(form, 'email'),
          firstName: getFieldValueByName(form, 'firstName'),
          lastName: getFieldValueByName(form, 'lastName'),
          phone: getFieldValueByName(form, 'phone'),
          address1: getFieldValueByName(form, 'address1'),
          town: getFieldValueByName(form, 'town'),
          state: getFieldValueByName(form, 'state'),
          country: getFieldValueByName(form, 'country'),
          region: getFieldValueByName(form, 'klaviyo_region'),
          postcode: getFieldValueByName(form, 'postcode'),
          dob: dob,
          productType: getFieldValueByName(form, 'productType'),
          productModel: productModelId,
          productModelId: productModelId,
          serialNumber: getFieldValueByName(form, 'serialNumber'),
          purchasePlace: getFieldValueByName(form, 'purchasePlace'),
          purchaseDate: getFieldValueByName(form, 'purchaseDate'),
          profession: getFieldValueByName(form, 'profession'),
          toolUsage: getFieldValueByName(form, 'toolUsage'),
          materials: getMultipleFieldValuesByName(form, 'materials').length > 0
          ? getMultipleFieldValuesByName(form, 'materials')
          : ['Not Given'],
          heard_from: getFieldValueByName(form, 'heard_from'),
          newsletter: newsletterYes.checked ? 'yes' : 'no',
          warrantyPeriod: warrantyPeriod,
          warrantyExpiry: warrantyExpiry ? warrantyExpiry.toISOString().split('T')[0] : null,
          receiptPhotoKey: receiptKey || null,
          receiptPhotoUrl: receiptUrl || null,
          file_name: receiptFileName || null,
        
          // ✅ This is what your Worker wants:
          salesforce: {
            email: getFieldValueByName(form, 'email'),
            firstName: getFieldValueByName(form, 'firstName'),
            lastName: getFieldValueByName(form, 'lastName'),
            phone: getFieldValueByName(form, 'phone'),
            productModel: productModelId,
            serialNumber: getFieldValueByName(form, 'serialNumber'),
            purchaseDate: getFieldValueByName(form, 'purchaseDate'),
            country: getFieldValueByName(form, 'country'),
            address1: getFieldValueByName(form, 'address1'),
            town: getFieldValueByName(form, 'town'),
            state: getFieldValueByName(form, 'state'),
            postcode: getFieldValueByName(form, 'postcode'),
            region: getFieldValueByName(form, 'klaviyo_region'),
            warrantyExpiry: warrantyExpiry ? warrantyExpiry.toISOString().split('T')[0] : null,
          },
        
          // Klaviyo settings
          klaviyo: {
            region: klaviyoRegion,
            listId: klaviyoListId,
          },

          recaptchaToken: token,
          website_url: window.location.href
        };


        console.log('Submitting payload:', payload);
        
        // ✅ If your upload function returns `url`, you can set it here too
        if (receiptKey && uploadResult?.url) {
          payload.receiptPhotoUrl = uploadResult.url;
        }

        console.log("✅ Submitting this payload:", payload);
        console.log("📤 Submitting to Salesforce with:", payload.salesforce);
        console.log("🎯 Final payload", payload);

        const response = await fetch('https://mr-register-form.matt-robinson-0dd.workers.dev', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        const result = await response.json();

        if (result.error) throw new Error(result.error);

        document.getElementById('successMessage').style.display = 'flex';
        document.getElementById('successCloseBtn').addEventListener('click', function () {
          document.getElementById('successMessage').style.display = 'none';
        });

        form.reset();
        setCurrentStep(1);

        document.querySelectorAll('.product-item').forEach(item => item.classList.remove('selected'));
        selectedProductInput.value = '';

      } catch (error) {
        console.error('Detailed error:', error);
        alert('Error submitting warranty registration: ' + error.message);
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit';
      }
    });
  });  
  });

  // 7. Popup Modal Logic
  const popupContainer = document.getElementById('customPopupContainer');
  const popupTriggers = document.querySelectorAll('.popup-trigger');
  const overlay = document.getElementById('customPopupOverlay');
  const closeButton = document.querySelector('.custom-popup-close');
  
  function showPopup(contentHTML) { 
    popupContainer.innerHTML = contentHTML; // Inject custom content
    overlay.style.display = 'flex'; // Show overlay
    document.body.style.overflow = 'hidden'; // Disable scrolling
  }
  function closePopup() { 
    overlay.style.display = 'none'; // Hide overlay
    popupContainer.innerHTML = ''; // Clear popup content
    document.body.style.overflow = 'auto'; // Re-enable scrolling  
  }
  
  popupTriggers.forEach(trigger => { 
    trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const contentId = this.getAttribute('data-popup-content'); // Get the ID of the content to show
        const contentHTML = document.getElementById(contentId).innerHTML; // Fetch the HTML
        showPopup(contentHTML); // Show the popup with fetched content
    });
  });
  closeButton.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
          closePopup();
      }
  });
  document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
          closePopup();
      }
  });

  // 8. Consent Toggle Handling
  const consentCheckbox = document.querySelector('[data-id="consent"]');
  submitBtn.disabled = !consentCheckbox.checked;
  consentCheckbox.addEventListener('change', function() {
    submitBtn.disabled = !this.checked;
  });

});  